/**
 * Full-bleed brand loader from the "Desktop · Auth & loading" design: isotipo in a frosted tile,
 * "Preparando tu próxima aventura.", a progress bar, and the white wordmark at the foot.
 */
export function BrandSplash({ label = "Preparando tu próxima", headline = "aventura." }: { label?: string; headline?: string }) {
  return (
    <div className="brand-splash" role="status" aria-live="polite" aria-label={`${label} ${headline}`}>
      <div className="brand-splash-glow" aria-hidden="true" />
      <div className="brand-splash-body">
        <div className="brand-splash-tile"><img src="/isotipo-cropped.png" alt="" /></div>
        <div className="brand-splash-copy">
          <span>{label}</span>
          <strong>{headline}</strong>
        </div>
        <div className="brand-splash-bar" aria-hidden="true"><span /></div>
      </div>
      <img className="brand-splash-logo" src="/logo-aventuria-white-cropped.png" alt="Aventuria" />
    </div>
  );
}
